import { render, staticRenderFns } from "./createProduct.vue?vue&type=template&id=4daf807a&scoped=true&"
import script from "./createProduct.vue?vue&type=script&lang=js&"
export * from "./createProduct.vue?vue&type=script&lang=js&"
import style0 from "./createProduct.vue?vue&type=style&index=0&id=4daf807a&lang=scss&scoped=true&"
import style1 from "./createProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daf807a",
  null
  
)

export default component.exports